
<template>
  <!-- 面包屑 -->
  <div class="bread-crumb">
    <template v-for="(item, q) in pathList">
      <div :class="[!item.path ? 'no-cursor' : 'path']" :key="q" :style="{color:!item.path && '#999999'}"  @click="goToPath(item.path)">
        {{ item.name }}
      </div>
      <i class="el-icon-caret-right"  />
    </template>

  </div>
</template>

<script>

export default {
  props: {
    pathList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
    
    };
  },
  methods: {
    goToPath(path) {
      path && this.$router.push(path);
    },
  },
};
</script>

<style scoped lang='scss'>
.bread-crumb {
  display: flex;
  height: 6rem;
  font-size: 14px;
  align-items: center;

  i {
    margin: 0 0.8rem;
    color: #999999;
    &:last-child{
      display: none;
    }
  }

  .path {
    user-select: none;

    &:hover {
      cursor: pointer;
    }
  }
}
</style>
